// Module
var code = "<div class=\"row\"> <div class=\"col-lg-10\"> <h3 class=\"mt-1\" data-bind=\"restext: 'ChangePassword'\"></h3> <p data-bind=\"restext: 'ChangePasswordInstructions'\"></p> </div> </div> ";
// Exports
export default code;